var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-drive",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 28,
    height: 28,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M11.244,10.546l5.1-3.069a4.327,4.327,0,0,1,.732-2.943L15.241,5.638S5.668,11.4,5.668,11.4c-.2.11-.4.23-.593.357L5,11.794a8.35,8.35,0,1,0,6.239-1.249Zm-1.6,14.4A6.2,6.2,0,0,1,6.173,13.6l.549-.33a6.2,6.2,0,1,1,2.917,11.68Zm2.146-6.205a2.146,2.146,0,1,1-2.146-2.146A2.148,2.148,0,0,1,11.785,18.74ZM25.823,8.315a4.29,4.29,0,1,0-3.96,2.353l-2.944,4.8a4.328,4.328,0,0,1,.706,2.95l1.121-1.828S25.464,8.9,25.464,8.9A4.318,4.318,0,0,0,25.823,8.315ZM22,8.528a2.152,2.152,0,1,1,1.954-1.264l-.282.46A2.141,2.141,0,0,1,22,8.528Z",
    transform: "translate(0.088 -1.481)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDrive);
export default __webpack_public_path__ + "static/media/ico-drive.90ea55c638f63e1bee4fef691fa46570.svg";
export { ForwardRef as ReactComponent };